function hideTitleAndSetAspectRatio() {
    var images = document.querySelectorAll('img');
    images.forEach(function(img) {
        if (img.alt.includes("- Removable Patch -") || img.alt.includes("- Patch - Pull Patch -")) {
            var figure = img.closest('.productitem--image');
            if (!figure) {
                figure = img.closest('.productitem--image-primary');
            }
            var parent = img.closest('.productitem');
            var titleElement = null;
            if (parent !== null) {
                titleElement = parent.querySelector('.productitem--title');
            } else {
                console.log('Parent element not found.');
            }
            if (figure) {
                console.log('mobilleeeee   ');
                setTimeout(() => {
                    const sliderHolder = figure.closest('.flickity-viewport');
                    if (sliderHolder) {
                        setTimeout(() => {
                            sliderHolder.classList.add('flickity-viewport--removable-patch');
                        }, 400);
                    }
                },400);
                figure.style.aspectRatio = '13 / 9';
                parent.classList.add('productitem--removable-patch');
                titleElement.classList.add('productitem--removable-patch--title');
                titleElement.innerHTML = '';
                parent.closest(".productgrid--item").classList.add('productgrid--item--removable-patch');
            }
        }
    });
}

document.addEventListener("DOMContentLoaded", function () {
    function checkFlickityActivation() {
        if (window.flickityActivated) {
            console.log('Flickity is activated');
            hideTitleAndSetAspectRatio();
            clearInterval(intervalId);
        } else {
        console.log('Flickity is not yet activated, checking again...');
        }
    }
    let intervalId = setInterval(checkFlickityActivation, 200);
    hideTitleAndSetAspectRatio();
});

  
// function adjustCanvasSize() {
//     const canvases = document.querySelectorAll('.pplr .pplr_preview_wrapper canvas');
  
//     canvases.forEach(canvas => {
//       const aspectRatio = 13 / 11;
  
//       const width = canvas.parentElement.offsetWidth;
//       canvas.style.width = width + 'px';
  
//       const height = width / aspectRatio;
//       canvas.style.height = height + 'px';
//     });
//   }
  
//   adjustCanvasSize();
//   window.addEventListener('resize', adjustCanvasSize);



// In your theme.liquid or slider initialization code
document.addEventListener('DOMContentLoaded', function() {
  const fixSliderHeight = () => {
    const slider = document.querySelector('[data-subcollections-layout="slideshow"]');
    if (slider) {
      slider.style.height = '';
      if (typeof Flickity !== 'undefined') {
        Flickity.data(slider)?.resize();
      }
    }
  };
  
  // Run on load and whenever images load
  window.addEventListener('load', fixSliderHeight);
  document.addEventListener('lazyloaded', fixSliderHeight);
});

const progressBars = Array.from(document.querySelectorAll('.progress-bar-track'));

function updateProgressBar(cart) {
  const progressBarEl = document.querySelector('.buy-more-save-more-section');

  if (!progressBarEl) {
    return;
  }

  let qty = 0;
  cart.items.forEach(item => {
    const productType = item.productType.toLowerCase();
    if (productType.includes('patch')) {
      qty += item.quantity;
    }
  });

  const tiers = window.productProgressBarTiers;

  let remaining = 0;
  let percent = 0;

  if (qty < tiers.tier1.qty) {
    remaining = tiers.tier1.qty - qty;
    percent = tiers.tier1.percent;
  } else if (tiers.tier2.enabled === 'true' && qty < tiers.tier2.qty) {
    remaining = tiers.tier2.qty - qty;
    percent = tiers.tier2.percent;
  } else if (tiers.tier3.enabled === 'true' && qty < tiers.tier3.qty) {
    remaining = tiers.tier3.qty - qty;
    percent = tiers.tier3.percent;
  } else if (tiers.tier4.enabled === 'true' && qty < tiers.tier4.qty) {
    remaining = tiers.tier4.qty - qty;
    percent = tiers.tier4.percent;
  }

  const descriptionEl = progressBarEl.querySelector('.buy-more-save-more-description');
  const closingTextEl = progressBarEl.querySelector('.buy-more-save-more-closing-text');
  if (remaining > 0) {
    descriptionEl.style.display = '';
    closingTextEl.style.display = 'none';

    const remainingEl = descriptionEl.querySelector('.buy-more-save-more__remaining-value');
    const percentEl = descriptionEl.querySelector('.buy-more-save-more__percent-value');

    remainingEl.textContent = remaining;
    percentEl.textContent = percent + '%';
  } else {
    descriptionEl.style.display = 'none';
    closingTextEl.style.display = '';
  }

  let trackEl = progressBarEl.querySelector('.progress-bar-track[data-tier="0"]');
  let progress = 0;
  if (qty >= tiers.tier1.qty) {
    progress = 100;
  } else {
    progress = qty / tiers.tier1.qty * 100;
  }

  trackEl.dataset.target = progress;

  for (let tier = 1; tier < progressBars.length; tier++) {
    const currentTier = tiers['tier' + tier];
    const nextTier = ((tier + 1) < progressBars.length) ? tiers['tier' + (tier + 1)] : null;

    let active = false;
    progress = 0;

    if (qty >= currentTier.qty) {
      active = true;
      progress = 100;

      if (nextTier && qty <= nextTier.qty) {
        const qtyToNextTier = nextTier.qty - currentTier.qty;
        const remainingQty = qty - currentTier.qty;
        progress = remainingQty / qtyToNextTier * 100;
      }
    }

    trackEl = progressBarEl.querySelector(`.progress-bar-track[data-tier="${tier}"]`);
    trackEl.dataset.target = progress;

    const tickMarkEl = progressBarEl.querySelector(`.progress-bar-tick-mark[data-tier="${tier}"]`);
    tickMarkEl.dataset.active = active;
  }

  startProgressBarAnimation(progressBarEl, qty);
}

const BASE_DURATION = 300;

function animateProgressBar(progressBar){
  return new Promise(resolve => {
    const target = Math.max(0, Math.min(100, Number(progressBar.dataset.target) || 0));
    const fill = progressBar.querySelector('.progress-bar-fill');
    const tickMark = progressBar.parentElement.querySelector(`.progress-bar-tick-mark[data-tier="${progressBar.dataset.tier}"]`);

    const duration = Math.round(BASE_DURATION * (target / 100));
    const effectiveDuration = duration > 150 ? duration : 150;

    fill.style.transition = `width ${effectiveDuration}ms linear`;

    requestAnimationFrame(() => {
      fill.style.width = target + '%';
      fill.classList.toggle('progress-bar-fill--active', target > 0);
      if (tickMark) {
        tickMark.classList.toggle('active', tickMark.dataset.active === 'true');
      }
    });

    const start = performance.now();
    function tick(now){
      const t = Math.min(1, (now - start) / effectiveDuration);
      if(t < 1){
        requestAnimationFrame(tick);
      } else {
        resolve();
      }
    }
    requestAnimationFrame(tick);
  });
}

async function startProgressBarAnimation(progressBarEl, qty){
  await new Promise(r => setTimeout(r, 120));

  const oldQty = progressBarEl.dataset.qty ?? 0;
  progressBarEl.dataset.qty = qty;

  if (oldQty == qty) {
    return;
  }

  if (oldQty < qty) {
    for(const progressBar of progressBars){
      await animateProgressBar(progressBar);
      await new Promise(r => setTimeout(r, 180));
    }
  } else {
    for (let i = progressBars.length - 1; i >= 0; i--) {
      const progressBar = progressBars[i];
      await animateProgressBar(progressBar);
      await new Promise(r => setTimeout(r, 180));
    }
  }
}

function disableFreeGiftAtc(cart) {
  cart.items.forEach(item => {
    if (item.originalPrice === 0) {
      const form = document.getElementById('product_form_' + item.productId);
      if (form) {
        const atcButton = form.querySelector('.product-form--atc-button');
        if (atcButton) {
          atcButton.classList.add('disabled');
          atcButton.disabled = true;
          atcButton.style.pointerEvents = 'none';
        }
      }
    }
  });
}

window.addEventListener('aftersell-upcart:public-events:cart-updated', (event) => {
  updateProgressBar(event.detail.cart);
  disableFreeGiftAtc(event.detail.cart);
});

class ProductRecommendations extends HTMLElement {
  buyMoreValueEl;
  buyMorePercentageEl;
  recsMoreEl;
  recsValueEl;
  recsPercentageEl;
  buyMoreEl;


  connectedCallback() {
    document.addEventListener('DOMContentLoaded', () => {
      this.loadRelatedRecommendations();

      this.recsMoreEl = this.querySelector('.recommendations-bmsm');
      this.recsValueEl = this.recsMoreEl.querySelector('.recommendations-bmsm__value');
      this.recsPercentageEl = this.recsMoreEl.querySelector('.recommendations-bmsm__percentage');

      this.buyMoreEl = document.querySelector('.buy-more-save-more-description');
      if (this.buyMoreEl) {
        this.buyMoreValueEl = document.querySelector('.buy-more-save-more__remaining-value');
        this.buyMorePercentageEl = document.querySelector('.buy-more-save-more__percent-value');

        this.updateRecommendationsBmsm();

        const observer = new MutationObserver((mutations) => {
          if (mutations.length) {
            this.updateRecommendationsBmsm();
          }
        });

        observer.observe(this.buyMoreEl, { childList: true, attributes: true, subtree: true });
      }

      this.setupAddToCartEvent();
    });
  }

  updateRecommendationsBmsm() {
    if (this.buyMoreEl.style.display === 'none') {
      this.recsMoreEl.setAttribute('hidden', '');
    } else {
      this.recsMoreEl.removeAttribute('hidden');
    }

    this.recsValueEl.textContent = this.buyMoreValueEl.textContent;
    this.recsPercentageEl.textContent = this.buyMorePercentageEl.textContent;
  }

  setupAddToCartEvent() {
    const addToCartBtn = this.querySelector('.recommendations__button');

    addToCartBtn.addEventListener('click', () => {
      let formData = { items: [] };

      const inputs = this.querySelectorAll('input[name="product-recommendation[]"]');
      inputs.forEach(input => {
        if (input.checked) {
          formData.items.push({
            id: input.value,
            quantity: 1
          });
        }
      });

      if (formData.items.length) {
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        });
      }
    });
  }

  loadRelatedRecommendations() {
    const productRecommendationsSection = this.querySelector('.related-recommendations');
    if (!productRecommendationsSection) {
      return;
    }

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.related-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}

(function () {
  let syncingBagging = false;
  let refreshingCart = false;

  window.addEventListener(
    'aftersell-upcart:public-events:cart-updated',
    async (event) => {
      const bagInput = document.getElementById('customer_needs_bags');

      console.log('bagInput', bagInput);

      if (syncingBagging || refreshingCart || !bagInput) {
        return;
      }

      const lineItems = event.detail?.cart?.items || [];

      const linesToUpdate = lineItems.filter((lineItem) => {
        const properties = lineItem.properties;
        return properties['_need_bags'] !== 'true';
      });

      if (linesToUpdate.length === 0) {
        return;
      }

      syncingBagging = true;

      console.log('linesToUpdate', linesToUpdate);

      try {
        for (const lineItem of linesToUpdate) {
          const properties = lineItem.properties;

          properties['_need_bags'] = 'true';

          await changeCartLine(
            lineItem.key,
            lineItem.quantity,
            properties
          );
        }

        refreshingCart = true;
        await window.upcartRefreshCart();
      } catch (error) {
        console.error(
          'Failed to mark cart items as needing a bag:',
          error
        );
      } finally {
        refreshingCart = false;
        syncingBagging = false;
      }
    }
  );

  async function changeCartLine(lineKey, quantity, properties) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity,
        properties
      })
    });

    if (!response.ok) {
      throw new Error(`Cart line update failed: ${response.status}`);
    }

    return response.json();
  }
})();